import { render, staticRenderFns } from "./Provinsi.old.vue?vue&type=template&id=3db5efec"
import script from "./Provinsi.old.vue?vue&type=script&lang=js"
export * from "./Provinsi.old.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports